import DevicesRoundedIcon from '@mui/icons-material/DevicesRounded';
import MoneyOffCsredRoundedIcon from '@mui/icons-material/MoneyOffCsredRounded';
import ShowChartRoundedIcon from '@mui/icons-material/ShowChartRounded';
import WatchLaterRoundedIcon from '@mui/icons-material/WatchLaterRounded';
import {
  Box,
  Button,
  Container,
  Grid,
  SxProps,
  Theme,
  Typography,
  useTheme,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { HeroDarkBgColor, HeroLightBgColor } from '../HomeView';

/**
 * An section on our home page that describes reasons to choose us
 */
const WhyChooseUsSection = () => {
  const theme = useTheme();
  const iconSx: SxProps<Theme> = {
    verticalAlign: 'middle',
    fontSize: '2em',
    mr: 2,
    mb: 0.7,
  };
  const fontSize = '1.1em';
  const commonImgSx: React.CSSProperties = {
    boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 4px 3px',
    borderRadius: '100%',
    objectFit: 'cover',
    filter: theme.palette.mode === 'dark' ? 'brightness(0.5)' : 'none',
  };

  return (
    <Box
      sx={{
        backgroundColor: (t) =>
          t.palette.mode == 'dark' ? HeroDarkBgColor : HeroLightBgColor,
        py: 6,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item container alignItems="center" xs={12} md={7}>
            <Box>
              <Box marginBottom={2}>
                <Typography
                  variant="h3"
                  sx={{ fontWeight: 700, mb: 4 }}
                  fontSize="2.2em"
                >
                  Built for Corporate, School, Healthcare, and Faith-Based Teams
                </Typography>
                <Box>
                  <Box sx={{ textAlign: 'left', m: 0 }}>
                    <Typography
                      variant="body1"
                      gutterBottom
                      fontSize={fontSize}
                    >
                      <DevicesRoundedIcon sx={iconSx} />
                      Self-paced and accessible from any device
                    </Typography>
                    <Typography
                      variant="body1"
                      gutterBottom
                      fontSize={fontSize}
                    >
                      <WatchLaterRoundedIcon sx={iconSx} />
                      About 30 minutes per course
                    </Typography>
                    <Typography
                      variant="body1"
                      gutterBottom
                      fontSize={fontSize}
                    >
                      <ShowChartRoundedIcon sx={iconSx} />
                      Easy to scale for teams of any size
                    </Typography>
                    <Typography
                      variant="body1"
                      gutterBottom
                      fontSize={fontSize}
                    >
                      <MoneyOffCsredRoundedIcon sx={iconSx} />
                      No extra setup fees
                    </Typography>
                  </Box>
                  <Box textAlign="center" mt={3}>
                    <Button
                      variant="contained"
                      color="primary"
                      size="large"
                      component={Link}
                      to="/about"
                    >
                      Learn More
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={5}>
            <Box
              height="100%"
              width="100%"
              display="flex"
              flexDirection="column"
              sx={{
                backgroundColor: 'transparent',
                backgroundImage:
                  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1600 900'%3E%3Cdefs%3E%3ClinearGradient id='a' x1='0' x2='0' y1='1' y2='0' gradientTransform='rotate(0,0.5,0.5)'%3E%3Cstop offset='0' stop-color='%230FF'/%3E%3Cstop offset='1' stop-color='%23CF6'/%3E%3C/linearGradient%3E%3ClinearGradient id='b' x1='0' x2='0' y1='0' y2='1' gradientTransform='rotate(0,0.5,0.5)'%3E%3Cstop offset='0' stop-color='%23F00'/%3E%3Cstop offset='1' stop-color='%23FC0'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cg fill='%23FFF' fill-opacity='0' stroke-miterlimit='10'%3E%3Cg stroke='url(%23a)' stroke-width='21.12'%3E%3Cpath d='M1409 581 1450.35 511 1490 581z'/%3E%3Ccircle stroke-width='7.040000000000001' transform='' cx='500' cy='100' r='40'/%3E%3Cpath transform='' d='M400.86 735.5h-83.73c0-23.12 18.74-41.87 41.87-41.87S400.86 712.38 400.86 735.5z'/%3E%3C/g%3E%3Cg stroke='url(%23b)' stroke-width='6.4'%3E%3Cpath transform='' d='M149.8 345.2 118.4 389.8 149.8 434.4 181.2 389.8z'/%3E%3Crect stroke-width='14.080000000000002' transform='' x='1039' y='709' width='100' height='100'/%3E%3Cpath transform='' d='M1426.8 132.4 1405.7 168.8 1363.7 168.8 1342.7 132.4 1363.7 96 1405.7 96z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\")",
                backgroundSize: 'contain',
              }}
            >
              <img
                src="/about-images/about-school.jpg"
                alt="Students and schools can benefit from the training"
                width={160}
                height={160}
                style={{
                  marginLeft: 'calc(60% - 160px)',
                  zIndex: 3,
                  ...commonImgSx,
                }}
              />
              <img
                width={200}
                height={200}
                src="/about-images/about-church.jpg"
                alt="Churches and their communities can benefit from the training"
                style={{
                  marginTop: '-8%',
                  zIndex: 2,
                  ...commonImgSx,
                }}
              />
              <img
                width={300}
                height={300}
                src="/about-images/about-business.jpg"
                alt="Business of all sizes can benefit from the training"
                style={{
                  marginTop: '-20%',
                  marginLeft: 'calc(100% - 300px)',
                  zIndex: 1,
                  ...commonImgSx,
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default WhyChooseUsSection;
